import { Container, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { OrderActionCreator } from '../../../actions/orderActions';
import { useOrder } from '../../../hooks/useOrders';
import type { Org } from '../../../api/schemas/OrgSchema';

import { OrderEditHeader } from './OrderEditHeader';
import OrderEditTabs from './orderEditTabs/OrderEditTabs';

/**
 * Container component for the order edit modal. Passes data from the store to
 * the rest of the order modal components.
 */

interface OrderEditProps {
  orderActions: any;
  close: () => void;
  orderUuid: string;
  orgs: Org[];
}

const OrderEdit = ({
  orderActions,
  close,
  orderUuid,
  orgs,
}: OrderEditProps) => {
  const { data: order, isLoading } = useOrder(orderUuid);
  const solarFarm = order?.solar_farm;

  return (
    <>
      {!isLoading ? (
        <Modal.Header closeButton>
          <Modal.Title style={{ width: '100%' }}>
            <OrderEditHeader
              order={order}
              solarFarm={solarFarm ?? null}
              orderActions={orderActions}
              close={close}
            />
          </Modal.Title>
        </Modal.Header>
      ) : null}
      <Container className="order-edit-container">
        <OrderEditTabs
          solarFarm={solarFarm ?? null}
          selectedOrder={order}
          orderActions={orderActions}
          orgs={orgs}
        />
      </Container>
    </>
  );
};

const mapStateToProps = () => ({});

// @ts-expect-error any type for now
const mapDispatchToProps = dispatch => ({
  orderActions: bindActionCreators(OrderActionCreator, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderEdit);
